import {useCurrentScheduleQuery} from '@domain/schedule'
import {Dialog} from '@mui/material'
import {Moment} from 'moment-timezone'
import React from 'react'

import {useScheduleCostAvoidanceDialog} from '../../../hooks'

import {CostAvoidanceDialogContent} from './CostAvoidanceDialogContent'

interface CostAvoidanceDialogProps {
  plantCode: string
  startOfPlan: Moment
  endOfPlan: Moment
}

export const CostAvoidanceDialog: React.FC<CostAvoidanceDialogProps> = ({
  plantCode,
  startOfPlan,
  endOfPlan
}) => {
  const {isDialogOpen} = useScheduleCostAvoidanceDialog()
  const {data: schedule} = useCurrentScheduleQuery({
    plantId: plantCode,
    range: [startOfPlan, endOfPlan]
  })
  const scheduleId = schedule?.scheduleId

  if (!scheduleId) {
    return null
  }

  return (
    <Dialog maxWidth="sm" fullWidth open={isDialogOpen}>
      <CostAvoidanceDialogContent scheduleId={scheduleId} />
    </Dialog>
  )
}
